import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { RouteName } from '@/router/RouteName';
import NotFound from '@/views/common/NotFound.vue';
import { logRoutes } from '@/autolog/autoLog';
import { useUser } from '@/store/pinia/userStore';
import { MyWWSDK } from '@/mixin/wecomJSSDK';

console.log('import.meta.env', import.meta.env);
const { MODE } = import.meta.env;

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'IndexPage',
    component: () => import('@/views/common/IndexPage.vue'),
    children: [
      {
        path: '',
        name: RouteName.HOME,
        component: () => import('@/views/Home.vue'),
        meta: {
          activeMenu: RouteName.HOME,
        },
      },
      {
        path: 'settings',
        name: RouteName.SETTINGS_INDEX,
        component: () => import('@/views/index/SettingsIndex.vue'),
        meta: {
          activeMenu: RouteName.SETTINGS_INDEX,
        },
        redirect: (to) => {
          return {
            name: RouteName.SETTING_DEPARTMENT_USER,
          };
        },
        children: [
          /**
           * 系统设置
           */
          {
            path: 'settingDepartmentUser',
            name: RouteName.SETTING_DEPARTMENT_USER,
            component: () => import('@/views/setting/SettingDepartmentUser.vue'),
          },
          {
            path: 'settingRole',
            name: RouteName.SETTING_ROLE,
            component: () => import('@/views/setting/SettingRole.vue'),
          },
          {
            path: 'settingData',
            name: RouteName.SETTING_DATA,
            component: () => import('@/views/setting/SettingsDataPermission.vue'),
          },
          {
            path: 'settingParameter',
            name: RouteName.SETTING_PARAMETER,
            component: () => import('@/views/setting/SettingParameter.vue'),
          },
          {
            path: 'settingCustomer',
            name: RouteName.SETTING_CUSTOMER,
            component: NotFound,
          },
          {
            path: 'settingSpace',
            name: RouteName.SETTING_SPACE,
            component: NotFound,
          },
          {
            path: 'settingLog',
            name: RouteName.SETTING_LOG,
            component: NotFound,
          },
          {
            path: 'settingSafety',
            name: RouteName.SETTING_SAFETY,
            component: NotFound,
          },
          ...logRoutes,
        ],
      },
      {
        path: 'msgaudit',
        name: RouteName.MSG_AUDIT_INDEX,
        component: () => import('@/views/index/MsgAuditIndex.vue'),
        meta: {
          activeMenu: RouteName.MSG_AUDIT_INDEX,
        },
        redirect: (to) => {
          return {
            name: RouteName.CHAT_RECORD_CUSTOMER,
          };
        },
        children: [
          {
            path: 'settings',
            name: RouteName.MSG_AUDIT_SETTINGS,
            component: () => import('@/views/msg-audit/MsgAuditSettings.vue'),
          },
          {
            path: 'record',
            name: RouteName.MSG_AUDIT_RECORD,
            component: () => import('@/views/msg-audit/MsgAuditRecord.vue'),
          },
          {
            path: 'edit',
            name: RouteName.MSG_AUDIT_SETTINGS_EDIT,
            component: () => import('@/views/msg-audit/MsgAuditSettingsEdit.vue'),
          },
          // {
          //   path: 'contact',
          //   name: RouteName.MSG_AUDIT_CONTACT,
          //   component: () => import('@/views/msg-audit/MsgAuditContact.vue'),
          // },
          {
            path: 'settings/contact',
            name: RouteName.EXTERNAL_CONTACT_SETTINGS,
            component: () => import('@/views/msg-audit/ExternalContactSettings.vue'),
          },
          {
            path: 'contactEdit',
            name: RouteName.EXTERNAL_CONTACT_SETTINGS_EDIT,
            component: () => import('@/views/msg-audit/ExternalContactSettingsEdit.vue'),
          },
          {
            path: 'globalSearch',
            name: RouteName.GLOBAL_SEARCH,
            component: () => import('@/views/msg-audit/GlobalSearch.vue'),
          },
          {
            path: 'chatRecord',
            name: RouteName.CHAT_RECORD,
            component: () => import('@/views/msg-audit/ChatRecord.vue'),
          },
          {
            path: 'chatRecordCustomer',
            name: RouteName.CHAT_RECORD_CUSTOMER,
            component: () => import('@/views/msg-audit/GlobalSearch.vue'),
            props: {
              privateChat: true,
              groupChat: false,
              title: '客户检索',
              description: '您在客户检索时必须填写【聊天内容】后再通过其他条件检索',
            },
          },
          {
            path: 'chatRecordGroup',
            name: RouteName.CHAT_RECORD_GROUP,
            component: () => import('@/views/msg-audit/ChatRecordRoom.vue'),
          },
          {
            path: 'chatRecordRevoke',
            name: RouteName.CHAT_RECORD_REVOKE,
            component: () => import('@/views/msg-audit/ChatRecordRevoke.vue'),
          },
          {
            path: 'chatRecordGroupRevoke',
            name: RouteName.CHAT_RECORD_GROUP_REVOKE,
            component: () => import('@/views/msg-audit/ChatRecordRevokeRoom.vue'),
          },
          {
            path: 'chatRecordVoiceCall',
            name: RouteName.CHAT_RECORD_VOICE_CALL,
            component: NotFound,
          },
          {
            path: 'settingVoice',
            name: RouteName.SETTING_VOICE,
            component: NotFound,
          },
          /**
           * 审计操作
           */
          {
            path: 'auditRecord',
            name: RouteName.AUDIT_RECORD,
            component: NotFound,
          },
          {
            path: 'auditType',
            name: RouteName.AUDIT_TYPE,
            component: NotFound,
          },
          /**
           * 客户管理
           */
          {
            path: 'customerList',
            name: RouteName.CUSTOMER_LIST,
            component: NotFound,
          },
          {
            path: 'customerWelcome',
            name: RouteName.CUSTOMER_WELCOME,
            component: NotFound,
          },
          /**
           * 数据统计
           */
          {
            path: 'statistics',
            name: RouteName.STATISTICS,
            component: NotFound,
          },
          /**
           * 敏感词设置
           */
          {
            path: 'sensitivityManage',
            name: RouteName.SENSITIVITY_MANAGE,
            component: () => import('@/views/keyword/Keyword.vue'),
          },
          {
            path: 'sensitivityRecord',
            name: RouteName.SENSITIVITY_RECORD,
            component: () => import('@/views/keyword/KeywordLog.vue'),
            props: (route) => {
              return {
                keyword: route.query.keyword,
              };
            },
          },
          {
            path: 'sensitivityNotice',
            name: RouteName.SENSITIVITY_NOTICE,
            component: () => import('@/views/keyword/KeywordNotice.vue'),
          },
          /**
           * 回复超时设置
           */
          {
            path: 'replyTimeoutManage',
            name: RouteName.REPLY_TIMEOUT,
            component: () => import('@/views/keyword/behavior/ReplyTimeout.vue'),
          },
          {
            path: 'replyTimeoutLog',
            name: RouteName.REPLY_TIMEOUT_LOG,
            component: () => import('@/views/keyword/behavior/ReplyTimeoutLog.vue'),
          },
          {
            path: 'ruleSave',
            name: RouteName.RULE_SAVE,
            component: () => import('@/views/rule/RuleSave.vue'),
            props: (route) => ({
              ruleId: route.query.ruleId,
            }),
          },
          {
            path: 'ruleList',
            name: RouteName.RULE_LIST,
            component: () => import('@/views/rule/RuleList.vue'),
          },
          /**
           * 导出中心
           */
          {
            path: 'export',
            name: RouteName.EXPORT,
            component: () => import('@/views/msg-audit/Export.vue'),
          },

          /**
           * 数据统计
           */
          {
            path: 'userBehaviorData',
            name: RouteName.USER_BEHAVIOR_DATA,
            component: () => import('@/views/data/UserBehaviorData.vue'),
          },
          {
            path: 'userContactData',
            name: RouteName.USER_CONTACT_DATA,
            component: () => import('@/views/data/UserBehaviorDetailData.vue'),
          },
          /**
           * 离职继承
           */
          {
            path: 'inheritAdmin',
            name: RouteName.INHERIT_ADMIN,
            component: () => import('@/data-inherit/views/AutoInheritAdmin.vue'),
          },
          {
            path: 'inheritList',
            name: RouteName.INHERIT_LIST,
            component: () => import('@/data-inherit/views/AutoInheritList.vue'),
          },
          {
            path: 'inheritContacts',
            name: RouteName.INHERIT_CONTACTS,
            component: () => import('@/data-inherit/views/AutoInheritExternalContacts.vue'),
          },

          /**
           * 特殊功能
           */
          {
            path: 'specialFunctionMail',
            name: RouteName.SPECIAL_FUNCTION_MAIL,
            component: () => import('@/components/special-function/AIMail.vue'),
          },
        ],
      },
    ],
  },

  {
    path: '/login',
    name: RouteName.LOGIN,
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/h5Login',
    name: RouteName.H5_LOGIN,
    component: () => import('@/views/H5Login.vue'),
  },
  {
    path: '/error',
    name: RouteName.ERROR,
    component: () => import('@/views/Error.vue'),
  },
  {
    path: '/notOpen',
    name: RouteName.NOT_OPEN,
    component: () => import('@/views/NotOpen.vue'),
  },
  {
    path: '/inheritSide',
    name: RouteName.INHERIT_SIDE,
    component: () => import('@/data-inherit/views/AutoInheritSideView.vue'),
  },
  {
    path: '/inheritGroupSide',
    name: RouteName.INHERIT_GROUP_SIDE,
    component: () => import('@/data-inherit/views/AutoInheritGroupSideView.vue'),
  },
  //邮件能力集成
  {
    path: '/aiMail',
    name: RouteName.AI_MAIL,
    component: () => import('@/components/special-function/AIMail.vue'),
  },
  {
    path: '/aiMailSummary',
    name: RouteName.AI_MAIL_SUMMARY,
    component: () => import('@/components/special-function/AIMailSummary.vue'),
  },
];
console.log('BASE_URL', import.meta.env.BASE_URL);
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

const IGNORE_ROUTES = [RouteName.LOGIN, RouteName.ERROR, RouteName.NOT_OPEN, RouteName.H5_LOGIN];
const MAIL_ROUTES = [RouteName.AI_MAIL, RouteName.AI_MAIL_SUMMARY];

router.beforeEach(async (to) => {
  if (IGNORE_ROUTES.includes(to.name as string)) {
    return true;
  }
  const userStore = useUser();
  if (userStore.user) {
    return true;
  }
  const user = await userStore.loadUser();
  if (user?.title) {
    document.title = user.title;
  }
  try {
    // if (/wechat/i.test(navigator.userAgent)) {
    //   MyWWSDK.registry();
    //   const checkResult = await MyWWSDK.getWW().checkJsApi({ jsApiList: ['getContext'] });
    //   console.log(checkResult);
    //   const context = await MyWWSDK.getWW().getContext();
    //   if (context.entry === 'single_chat_tools') {
    //     return { name: RouteName.INHERIT_SIDE };
    //   }
    // }
    MyWWSDK.registry();
    console.log(`navigator.userAgent${JSON.stringify(navigator.userAgent, null, 2)}`);
    if (/wechat|wxwork/i.test(navigator.userAgent)) {
      const checkResult = await MyWWSDK.getWW().checkJsApi({ jsApiList: ['getContext'] });
      const context = await MyWWSDK.getWW().getContext();
      console.log(`context${JSON.stringify(context, null, 2)}`);
      //若侧边栏处邮件路由
      if (MAIL_ROUTES.includes(to.name as string)) {
        return true;
      }
      if (['chat_attachment', 'single_chat_tools'].includes(context.entry)) {
        return { name: RouteName.INHERIT_SIDE };
      }
      if (['group_chat_tools'].includes(context.entry)) {
        return { name: RouteName.INHERIT_GROUP_SIDE };
      }
    }
  } catch (e) {
    console.error('wecomJSSDK', e);
  }
  return true;
});

router.afterEach(async (to) => {
  // const store = useStore();
  // console.log('store', store);
  const { autoCompanyId, appid, login_url } = to.query;
  // 关联 Login.vue
  if (autoCompanyId && appid && typeof autoCompanyId === 'string' && typeof appid === 'string') {
    localStorage.setItem('autoCompanyId', autoCompanyId);
    localStorage.setItem('appid', appid);
    // store.commit('setApplicationInfo', {
    //   autoCompanyId: to.query.autoCompanyId,
    //   appid: to.query.appid,
    // });
    // localStorage.setItem('loginType', 'third');
  }

  if (login_url && typeof login_url === 'string') {
    // localStorage.setItem('loginType', 'inside');
    localStorage.setItem('loginUrl', login_url);
  }

  // if (typeof to.name === 'string' && IGNORE_ROUTES.includes(to.name)) {
  //   return true;
  // }
  //
  // if (MODE === 'development') {
  //   return true;
  // }
  //
  // const url = window.location.href.split('#')[0];
  // try {
  //   await wxService.init(url);
  // } catch (e) {
  //   console.error(e);
  // }
  return true;
});

export default router;
